import { render, staticRenderFns } from "./CompletedQuestionsCard.vue?vue&type=template&id=b6e988b8"
import script from "./CompletedQuestionsCard.vue?vue&type=script&lang=ts"
export * from "./CompletedQuestionsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports